import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/index.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ChiSono } from "@/components/ChiSono";
import { Approccio } from "@/components/Approccio";
import { Servizi } from "@/components/Servizi";
import { Studio } from "@/components/Studio";
import { Contatti } from "@/components/Contatti";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink min-h-screen text-sand overflow-x-clip" data-testid="app-root">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ChiSono />
        <Approccio />
        <Servizi />
        <Studio />
        <Contatti />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#16181D",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F5F2EB",
          },
        }}
      />
    </div>
  );
}

export default App;
